import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const csrf = sessionStorage.getItem("tp-admin-csrf");
  if (csrf) config.headers["X-CSRF-Token"] = csrf;
  return config;
});
